module.exports = __webpack_public_path__ + "static/media/notes_active.2de95494.svg";